<template>
  <b-form-group
    class="custom-file-control"
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${
      validate.required === true ||
      (typeof validate === 'string' && validate.search('required') == true && validate.required == true)
        ? 'is-required'
        : ''
    }`"
  >
    <b-form-input v-model="_value" type="url" disabled> </b-form-input>
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <!--  TODO: required:  
          :class="{ 'empty' : !variable.value }"  -->

      <b-form-file
        @input="FileChanged"
        v-model="_file"
        :name="name"
        :accept="
          '.' +
          (validate.hasOwnProperty('ext') && validate.ext.length > 0
            ? validate.ext.join(',.')
            : '')
        "
        placeholder="Adjuntar archivo"
        :class="
          validationContext.errors.length > 0
            ? 'form-control is-invalid'
            : _value
            ? 'form-control is-valid'
            : ''
        "
      >
        <template slot="file-name" slot-scope="{ names }">
          <b-badge variant="primary">{{ names[0] }}</b-badge>
          <b-badge v-if="names.length > 1" variant="primary" class="ml-1">
            + {{ names.length - 1 }} más
          </b-badge>
        </template>
      </b-form-file>
      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
      <b-button v-if="_file" size="xs" variant="link" @click="_file = null"
        >Cancelar</b-button
      >
      <small v-if="helpText" class="text-muted">{{ helpText }}</small>
      <visualizerPdfImage :config="config" :file="_value" />
    </ValidationProvider>
  </b-form-group>
</template>

<script>
import visualizerPdfImage from '@components/form/visualizerPdfImage'
import { formMethods } from '@state/helpers'
export default {
  name: 'InputFile',
  component: {
    visualizerPdfImage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    validate: {
      type: [String, Object],
      required: false,
      default: '',
    },
    onchange: {
      type: Function,
      required: false,
      default: () => {},
    },
    config: {
      type: Object,
      required: false,
      default: null,
    },
    value: {
      type: [File],
      required: false,
      default: null,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'passive',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    size: {
      type: String,
      required: false,
      default: '',
    },
    step: {
      type: Number,
      required: false,
      default: 1,
    },
    autocomplete: {
      type: String,
      required: false,
      default: '',
    },
    showErrorMessage: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    helpText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value_instance: false,
      _file: null,
      _value: null,
    }
  },
  computed: {
    _value: {
      get(obj) {
        return this.value
      },
      set(value) {
        this.value_instance = value instanceof File
        this.$emit('update:value', value)
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...formMethods,
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null
    },
    removeReadonly(event) {
      // fix error readonly on multiple validations?
      if (event.currentTarget.getAttribute('readonly') == 'readonly') {
        event.currentTarget.removeAttribute('readonly')
        event.currentTarget.style.backgroundColor = 'white'
      }
    },
    FileChanged() {
      this.value_instance = this._file
      if (this._file) {
        let form = parseInt(this.$route.params.formId)
        let context = this
        context.fileLogoLoader = true
        let File = this._file
        let formData = new FormData()
        let keyFile = this.config.variable + '_' + form + '_' + Date.now()
        let TempFile = this._value ? this._value.split('/').pop() : ''
        formData.append('File', File)
        formData.append('KeyFile', keyFile)
        formData.append('TempFile', TempFile)
        context
          .setVariableFile({ formData })
          .then((data) => {
            this.config.value = data.URL
            this.value = data.URL
            context.$generate_toast(
              context,
              'success',
              'Archivo Almacenado exitosamente'
            )
            context.fileLogoLoader = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.fileLogoLoader = false
          })
      }
    },
  },
  watch: {
    _value(newValue, oldValue) {
      // console.log(newValue)
    },
  },
}
</script>
<style lang="scss" >
.custom-file-control {
  .form-control {
    height: calc(1.5em + 0.95rem + 3px);
  }
}
.form-file-text {
  color: #adadad;
  font-size: 12px;
}
</style>